import React, { Component } from 'react';
import Helmet from 'react-helmet';
import map from 'lodash/map';
import { css } from 'glamor';

// import range from 'lodash/range';
import slice from 'lodash/slice';
import Image from '../components/Image';
import WorkNav from '../components/WorkNav';
import Loader from '../components/Loader';
import Animated from '../components/Animated';
import Video from '../components/Video';

import {
  wrapper,
  fullWidth,
  // halfWidth,
  thirdWidth,
  imageWrapper,
  wideContainer,
  textContainer,
  removePaddingVertical,
  center,
  fillButton,
  shadowless,
  nowrap,
} from '../styles';

const row1 = (image, index) => {
  return (
    <div {...fullWidth} key={`image-${index}`}>
      <Image sources={image} />
    </div>
  );
};

// const row2 = (image, index) => {
//   return (
//     <div {...halfWidth} key={`image-${index}`}>
//       <Image sources={image} />
//     </div>
//   );
// };

const row3 = (image, index) => {
  return (
    <div {...thirdWidth} key={`image-${index}`}>
      <Image sources={image} />
    </div>
  );
};

class CommunityGardens extends Component {
  constructor(props) {
    super(props);

    const headerImage = this.getImage(
      'community-gardens',
      'community-gardens-header',
      1
    );
    const videoImage = this.getImage(
      'community-gardens',
      'community-gardens-video',
      1
    );

    this.state = { headerImage, videoImage, set1: [] };
  }

  getImage = (folder, filename, r) => {
    return [
      {
        srcSet: require(`../assets/${folder}/${filename}-thumb-${r}.jpg`),
        media: '(max-width: 100px)',
      },
      {
        srcSet: require(`../assets/${folder}/${filename}-sm-${r}.jpg`),
        media: '(max-width: 720px)',
      },
      {
        srcSet: require(`../assets/${folder}/${filename}-${r}.jpg`),
      },
    ];
  };

  componentWillMount() {
    this.props.load();
    this.props.loadTheme();
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.communityGardens &&
      nextProps.communityGardens.images &&
      !this.state.set1.length
    ) {
      const set1 = slice(nextProps.communityGardens.images, 5, 18);
      this.setState({ set1 });
    }
  }

  render() {
    const { communityGardens, theme } = this.props;
    if (!communityGardens || !communityGardens.images) {
      return <Loader />;
    }

    const allImages = communityGardens.images;
    const { set1, headerImage, videoImage } = this.state;
    const { prev, next } = this.props;
    return (
      <div>
        <Helmet
          title="Community Gardens by lucastswick"
          description="Community Gardens is a data-driven generative art installation about food and housing insecurity among the student body at NC State."
          meta={[
            {
              property: 'og:image:url',
              content: `https://generativeartist.com${allImages[0][2].srcSet}`,
            },
            {
              property: 'twitter:image',
              content: `https://generativeartist.com${allImages[0][2].srcSet}`,
            },
          ]}
        />
        <Image ratio="16x9" sources={headerImage} />

        <div {...textContainer}>
          <Animated as="h1">Community Gardens</Animated>
          <Animated delay={150}>
            <a
              href="http://communitygardens.generativeartist.com/"
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              Community Gardens
            </a>{' '}
            is a data-driven generative art installation about food and housing
            insecurity among the student body at NC State.
          </Animated>
          <Animated delay={300}>
            Data reveals that 9.6% of students at NC State experienced
            homelessness in the past year. However, most people don't imagine
            students when thinking about homelessness, so it's been difficult
            for affected students to be heard.
          </Animated>
          <div {...imageWrapper}>{row1(allImages[0], 0)}</div>
          <Animated as="h2">Metaphor</Animated>
          <Animated>
            The central metaphor to the project is gardens. In summer, plants
            have all the resources they need to thrive. In winter, less so. It's
            not a fault of the plant that the environment doesn't supply and
            support them.
          </Animated>
          <div {...imageWrapper}>{row1(allImages[2], 0)}</div>
          <Animated>
            Each plant is extremely expressive and representative of the source
            data. Plants that have staggered stems are anxious, petals that are
            blown away represent housing insecurity, and berries that are
            displaced from the leaves indicate food insecurity. There are about
            15 different ways that a plant can express the student's attributes.
          </Animated>
          <div {...imageWrapper}>{row1(allImages[3], 0)}</div>
          <Animated as="h2">Purpose</Animated>
          <Animated>
            The main purpose of Community Gardens is to create awareness. People
            are initially attracted to the installation due to the organic
            movement and deliberate pacing, and can then scan a QR code to learn
            about each plant and what they can do to help combat food and
            housing insecurity.
          </Animated>
          <Animated>
            The technical goal I set for myself was to create a more gestural
            form of generative art. By using watercolor strokes for the stems
            and animating them, it appears as though someone is drawing each
            plant. But it's just an algorithm!
          </Animated>
        </div>
        <div {...wideContainer} {...removePaddingVertical}>
          <Video videoId={'313697626'} sources={videoImage} />
        </div>
        <div {...textContainer}>
          <Animated as="h2">Colors &amp; Localization</Animated>
          <Animated>
            I wanted to localize the installation to North Carolina as much as
            possible. The plants I wrote algorithms for all grow in North
            Carolina, and the colors are actually sampled from Raleigh.
          </Animated>
          <Animated>
            I took my camera out for photowalks during my residency and then
            wrote software that allows me to tag pixels as leaf, bark, ground,
            and sky. These colors are then fed directly to the installation,
            creating a sense of familiarity for viewers.
          </Animated>
        </div>
        <div {...wrapper}>
          {map(set1, (image, index) => {
            if (index % 4 === 0) {
              return (
                <div key={`image-${index}`} {...textContainer}>
                  {row1(image, index)}
                </div>
              );
            } else {
              return row3(image, index);
            }
          })}
        </div>
        <div {...textContainer}>
          <Animated as="h1">See it in action</Animated>
          <Animated>
            You can either head to the{' '}
            <a
              href="https://www.lib.ncsu.edu/huntlibrary"
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              Hunt Library
            </a>{' '}
            at NC State, or view the installation here:{' '}
            <a
              href="https://communitygardens.generativeartist.com/"
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              Community Gardens
            </a>{' '}
            .
          </Animated>
          <div {...center} {...css({ margin: '3rem 0' })}>
            <Animated>
              <a
                {...nowrap}
                {...fillButton}
                {...shadowless}
                {...css(
                  theme &&
                    theme.colors && {
                      color: theme.colors[0],
                      background: theme.colors[1],
                      transition: 'all 0.2s',
                    }
                )}
                {...css(
                  theme &&
                    theme.colors && {
                      '&:hover': {
                        textDecoration: 'none',
                        color: '#333',
                        background: theme.colors[2],
                      },
                    }
                )}
                href="https://communitygardens.generativeartist.com/"
                target="_blank"
                rel="nofollow noopener noreferrer"
              >
                Visit Community Gardens
              </a>{' '}
            </Animated>
          </div>
          <Animated>
            <i>
              This project was funded by the{' '}
              <a
                href="https://mellon.org/"
                target="_blank"
                rel="nofollow noopener noreferrer"
              >
                Andrew W. Mellon Foundation
              </a>{' '}
              through the{' '}
              <a
                href="https://www.immersivescholar.org/"
                target="_blank"
                rel="nofollow noopener noreferrer"
              >
                Immersive Scholar
              </a>{' '}
              program.
            </i>
          </Animated>
        </div>
        <WorkNav prev={prev} next={next} />
      </div>
    );
  }
}

export default CommunityGardens;



// WEBPACK FOOTER //
// ./src/pages/CommunityGardens.js